export default __webpack_public_path__ + "static/media/Gophr_G_RGB.edd5e567.png";